<template>
  <div class="block">
    <div class="block-title header">
      <div class="title">达人列表</div>
    </div>
    <list></list>
  </div>
</template>

<script>
import List from './components/list.vue'
export default {
  components:{
    List
  }
}
</script>

<style scoped lang="less">
.header{
  display: flex;
  justify-content: space-between;
  .title{
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/philosopherList.vue